/**
 * Returns a controller item by its id, or undefined when not found.
 * @param {Array} items - controller items
 * @param {string} itemId - item id
 * @returns {Object|undefined}
 */
export const getItemById = (items, itemId) => {
    return items?.find((item) => item._id === itemId);
};
